import { render, staticRenderFns } from "./popup-header.vue?vue&type=template&id=800070c8&scoped=true&"
import script from "./popup-header.vue?vue&type=script&lang=js&"
export * from "./popup-header.vue?vue&type=script&lang=js&"
import style0 from "./popup-header.vue?vue&type=style&index=0&id=800070c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800070c8",
  null
  
)

export default component.exports